import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Callback from 'containers/Callback';
import Email from 'containers/Email';
import ResentedEmail from 'containers/ResentedEmail';
import ResentedEmailError from 'containers/ResentedEmail/Error';
import Phone from 'containers/Phone';
import News from 'containers/News';
import SuspendedUser from 'containers/SuspendedUser';
import SuccessRecoverUser from 'containers/SuccessRecoverUser';
import Error from 'containers/Error';
// import FakeLogin from 'components/FakeLogin';
import CallbackApp from 'containers/CallbackApp';
import { RegisterSuccess } from 'pages/RegisterSucess';
import { FirstAccessFlow } from 'pages/FirstAccessFlow';
import { RedoRegisterTangie } from 'pages/RedoRegisterTangie';
import { RedoRegisterTangieSuccess } from 'pages/RedoRegisterTangieSuccess';
import ConfirmRegister from 'containers/ConfirmRegister';
import { useLDVariants } from 'context/LaunchDarklyProvider';
import { CobrandedConfirm } from 'containers/CobrandedConfirm';
import PrivateRoute from './PrivateRoute';

const Routes: React.FC = () => {
  const redoRegisterTangie = true;

  const variants = useLDVariants();

  return (
    <BrowserRouter>
      <Switch>
        <Route path="/validar/" exact>
          <Callback />
        </Route>
        <Route path="/validar/app" exact>
          <CallbackApp />
        </Route>
        <Route path="/validar/email" exact>
          <Email />
        </Route>
        <PrivateRoute path="/validar/reenvioemail" exact>
          <ResentedEmail />
        </PrivateRoute>
        <PrivateRoute path="/validar/reenvioemail/erro" exact>
          <ResentedEmailError />
        </PrivateRoute>
        <PrivateRoute path="/validar/celular" exact>
          <Phone />
        </PrivateRoute>
        <PrivateRoute path="/validar/novidades" exact>
          <News />
        </PrivateRoute>
        <PrivateRoute path="/validar/conta-suspensa" exact>
          <SuspendedUser />
        </PrivateRoute>
        <PrivateRoute path="/validar/analise-conta-suspensa" exact>
          <SuspendedUser checkingSuspended />
        </PrivateRoute>
        <Route path="/validar/recadastramento" exact>
          <RedoRegisterTangie />
        </Route>
        <Route path="/validar/recadastramento/sucesso" exact>
          {redoRegisterTangie ? <RedoRegisterTangieSuccess /> : <RegisterSuccess />}
        </Route>
        <Route path="/validar/sucesso" exact>
          <SuccessRecoverUser />
        </Route>
        <Route path="/validar/confirmar-dados" exact>
          {variants.flags.tangieConfirmCobranded ? <CobrandedConfirm /> : <ConfirmRegister />}
        </Route>
        <Route path="/validar/erro" exact>
          <Error />
        </Route>
        <Route path="/validar/acesso" exact>
          <FirstAccessFlow />
        </Route>
        <Redirect to="/validar" />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
